import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { Alert, Row, Col } from 'components/patterns'
import { StyledTable } from './ConflictingSwitches.style'

const columns = [
  {
    title: strings.item_no,
    dataIndex: 'panelNumber',
    width: 170,
  },
  {
  title: strings.switch_description,
    dataIndex: 'panelDescription',
  },
]

const ConflictingSwitches = ({
  currentConflictingSwitches
}) => {
  
  return (
    <>
      <Row>
        <Col span={24}>
          <Alert
            persistent
            type={'warning'}
            message={strings.there_is_no_available_space_on_msf}
            closeable={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <StyledTable
            title={strings.switches_used_will_be_added_to_inventory}
            size="small"
            columns={columns}
            dataSource={currentConflictingSwitches}
            pagination={false}
            rowKey={(record) => record.panelNumber}
          />
        </Col>
      </Row>
    </>
  )
}

ConflictingSwitches.propTypes = {
  currentConflictingSwitches: PropTypes.array
}

export default ConflictingSwitches